import axios from "axios";

const cameraAuth = axios.create({
  baseURL: process.env.REACT_APP_BE_AI,
});
export default cameraAuth;

